var _defs, _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocation = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    width: 10.498,
    height: 13.177,
    viewBox: "0 0 10.498 13.177",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M23.455,6.4A5.267,5.267,0,0,0,18.2,11.666a5.34,5.34,0,0,0,.1,1.044c0,.023.011.045.011.079.579,2.6,4.653,6.5,4.823,6.662a.436.436,0,0,0,.318.125.488.488,0,0,0,.318-.125c.17-.17,4.222-4.063,4.8-6.605,0-.023.011-.045.011-.068A5.289,5.289,0,0,0,23.455,6.4Zm4.222,6.208v.034c-.431,1.884-3.257,4.858-4.222,5.822-.965-.965-3.8-3.938-4.233-5.868a.1.1,0,0,0-.011-.057,4.687,4.687,0,0,1-.091-.885,4.33,4.33,0,1,1,8.557.953Z",
    transform: "translate(-18.2 -6.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M50.759,32.5a1.759,1.759,0,1,0,1.759,1.759A1.761,1.761,0,0,0,50.759,32.5Zm0,2.6a.84.84,0,1,1,.84-.84A.838.838,0,0,1,50.759,35.1Z",
    transform: "translate(-45.504 -29.538)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.cfc8852d.svg";
export { ForwardRef as ReactComponent };